import { render, staticRenderFns } from "./right-table.vue?vue&type=template&id=51134f8e&scoped=true&"
import script from "./right-table.vue?vue&type=script&lang=ts&"
export * from "./right-table.vue?vue&type=script&lang=ts&"
import style0 from "./right-table.vue?vue&type=style&index=0&id=51134f8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51134f8e",
  null
  
)

export default component.exports